import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { BasicButton, TitleText, BasicText, Space } from '@components';
import { logoutUser } from '@actions';
import { COLORS } from "@global";
import styles from './AdminMenuWrapper.module.css';
import logo from '@images/logo-trans.png';

const AdminMenuWrapper = ({ children, getAdminEvents, logoutUser, logged_in, liveUrl }) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const isCancelled = useRef(false);

  const handleLogout = () => {
    setLoading(true);
    logoutUser(
      () => {
        history.push({
          pathname: '/admin/login',
        })},
      () => {
        history.push({
          pathname: '/admin/login',
      })}
    )
  }

  const isViewingPath = (path) => {
    return window.location.href.includes(path);
  }

  const isOnUserPath = () => {
    return (
      window.location.href.includes("/admin") &&

      !(window.location.href.includes("/groups") || window.location.href.includes("/quotes") || window.location.href.includes("/reports"))
    )
  }

  return (
    <div>
      <div className={styles.menu_conatiner_style}>
        <div className={styles.links_container}>
          <div className={styles.home_text} onClick={() => history.push({ pathname: '/home' })}>
            <img src={logo} style={{ maxWidth: "40px" }} />
          </div>

          {logged_in &&
            <div
              className={styles.menu_option_container}
              style={{ backgroundColor: isOnUserPath() ? COLORS.PRIMARY_COLOR : ""}}
              onClick={() => history.push({ pathname: '/admin' })}
            >
              <BasicText fontSize="15px" color="#fff">Users</BasicText>
            </div>
          }

          {logged_in &&
            <div
              className={styles.menu_option_container}
              style={{ backgroundColor: isViewingPath('/admin/quotes') ? COLORS.PRIMARY_COLOR : ""}}
              onClick={() => history.push({ pathname: '/admin/quotes' })}
            >
              <BasicText fontSize="15px" color="#fff">Quotes</BasicText>
            </div>
          }

          {logged_in &&
            <div
              className={styles.menu_option_container}
              style={{ backgroundColor: isViewingPath('/admin/groups') ? COLORS.PRIMARY_COLOR : ""}}
              onClick={() => history.push({ pathname: '/admin/groups' })}
            >
              <BasicText fontSize="15px" color="#fff">Groups</BasicText>
            </div>
          }

          {logged_in &&
            <div
              className={styles.menu_option_container}
              style={{ backgroundColor: isViewingPath('/admin/reports') ? COLORS.PRIMARY_COLOR : ""}}
              onClick={() => history.push({ pathname: '/admin/reports' })}
            >
              <BasicText fontSize="15px" color="#fff">Reports</BasicText>
            </div>
          }

        </div>

        {logged_in &&
          <BasicButton
            text="Logout"
            loading={loading}
            onClick={() => handleLogout()}
            style={{ backgroundColor: "rgba(0,0,0,0)", color: "#fff" }}
          />
        }
      </div>

      <div className={styles.content_container}>
        {children}
      </div>
    </div>
  )
}

const mapStatesToProps = (state) => {
  const { events, liveUrl } = state.admin;
  const { logged_in } = state.auth;
  return { events, logged_in, liveUrl };
};


export default connect(mapStatesToProps, {
  logoutUser
})(AdminMenuWrapper);
